







import ApiHelpers from '@/api/ApiHelper';
import { Vue, Component, Prop } from 'vue-property-decorator';

declare global {
  interface Window {
    CKEDITOR: any;
  }
}

@Component({
  components: {
  },
})
export default class CkEditor extends Vue {
  @Prop(String) content!: string;
  loadContent: string = this.content;

  private editorUrl = 'https://cdn.ckeditor.com/4.14.1/full-all/ckeditor.js';
  private editorConfig = {
    language: 'ja',
    font_names:
      'Noto San JP/Noto Sans JP, sans-serif;' +
      'Arial/Arial, Helvetica, sans-serif;' +
      'Comic Sans MS/Comic Sans MS, cursive;' +
      'Courier New/Courier New, Courier, monospace;' +
      'Georgia/Georgia, serif;' +
      'YuGothic/YuGothic, YuGothic, sans-serif;' +
      'Lucida Sans Unicode/Lucida Sans Unicode, Lucida Grande, sans-serif;' +
      'Tahoma/Tahoma, Geneva, sans-serif;' +
      'Times New Roman/Times New Roman, Times, serif;' +
      'Trebuchet MS/Trebuchet MS, Helvetica, sans-serif;' +
      'Verdana/Verdana, Geneva, sans-serif',
    toolbarGroups: [
      { name: 'document', groups: ['mode', 'document', 'doctools'] },
      { name: 'clipboard', groups: ['clipboard', 'undo'] },
      { name: 'editing', groups: ['find', 'selection', 'spellchecker', 'editing'] },
      { name: 'forms', groups: ['forms'] },
      { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
      { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align', 'bidi', 'paragraph'] },
      { name: 'links', groups: ['links'] },
      { name: 'insert', groups: ['insert'] },
      { name: 'colors', groups: ['colors'] },
      { name: 'styles', groups: ['styles'] },
      { name: 'tools', groups: ['tools'] },
      { name: 'others', groups: ['others'] },
      { name: 'about', groups: ['about'] },
    ],
    removeButtons:
      `Radio,Preview,Maximize,NewPage,Print,Save,Templates,` +
      `Replace,Find,SelectAll,Scayt,Form,TextField,Textarea,` +
      `Select,Button,ImageButton,HiddenField,CreateDiv,Anchor,` +
      `Flash,Smiley,PageBreak,ShowBlocks,About,Language,Iframe,` +
      `Paste,PasteText,PasteFromWord`,

    extraPlugins: 'image2',
    removePlugins: 'image,easyimage,cloudservices',
    removeDialogTabs: 'image:advanced;image:Link',
    filebrowserUploadMethod: 'xhr',
    image2_alignClasses: ['image-left', 'image-center', 'image-right'],
    image2_captionedClass: 'image-captioned',
    filebrowserUploadUrl: 'api/v2/managers/signed-url',
  };

  async mounted() {
    await this.loadCKEditor();
  }

  private onEditorChange(event: any) {
    if (event && event.editor) {
      this.loadContent = event.editor.getData();
      this.$emit('onChange', this.loadContent);
    }
  }

  private updateContent(newContent: string | null) {
    if (newContent !== null) {
      this.loadContent = newContent;
      this.$emit('onChange', this.loadContent);
    }
  }

  private loadCKEditor() {
    if (!window.CKEDITOR) {
      const script = document.createElement('script');
      script.src = this.editorUrl;
      script.onload = () => {
        this.initializeEditor();
      };
      document.head.appendChild(script);
    } else {
      this.initializeEditor();
    }
  }

  private initializeEditor() {
    const self = this;
    window.CKEDITOR.on('instanceReady', () => {
      const editorInstance = window.CKEDITOR.instances[Object.keys(window.CKEDITOR.instances)[0]];
      if (editorInstance) {
        editorInstance.on('fileUploadRequest', async (evt: any) => {
          evt.stop();
          const file = evt.data.fileLoader.file;

          if (!file) {
            evt.cancel();
            return;
          }

          try {
            self.$emit('onUploadStateChange', true);

            const body = {
              file_name: file.name,
              content_type: file.type,
            };

            const response = await ApiHelpers.getApi('UploadImageApi').uploadImage(body);
            const data = await response.data;
            const signedUrl = data.signed_url;

            await fetch(signedUrl, {
              method: 'PUT',
              headers: { 'Content-Type': file.type },
              body: file,
            });

            const dialog = window.CKEDITOR.dialog.getCurrent();
            if (dialog) {
              const editorInstance = dialog.getParentEditor();
              editorInstance.insertHtml(
                `<img src="${data.url}" alt="${file.name}"/>`,
              );
              dialog.hide();
            } else {
              editorInstance.insertHtml(
                `<img src="${data.url}" alt="${file.name}"/>`,
              );
            }

            evt.data.fileLoader.url = data?.url;
            evt.data.fileLoader.responseData = JSON.stringify({ url: evt.data.fileLoader.url });
            evt.data.fileLoader.changeStatus('uploaded');
          } catch (error) {
            evt.data.fileLoader.message = 'Upload failed!';
            evt.data.fileLoader.changeStatus('error');
          } finally {
            self.$emit('onUploadStateChange', false);
          }
        });
      }
    });
  }
}
